import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/OY-Belleza/OY-Belleza/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/OY-Belleza/OY-Belleza/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["LandingAnalytics"] */ "/home/runner/work/OY-Belleza/OY-Belleza/src/components/analytics/LandingAnalytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQ"] */ "/home/runner/work/OY-Belleza/OY-Belleza/src/components/sections/FAQ.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Features"] */ "/home/runner/work/OY-Belleza/OY-Belleza/src/components/sections/Features.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HowItWorks"] */ "/home/runner/work/OY-Belleza/OY-Belleza/src/components/sections/HowItWorks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PricingPlanCard"] */ "/home/runner/work/OY-Belleza/OY-Belleza/src/components/sections/PricingPlanCard.tsx");
